import React, { type ReactNode } from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource-variable/inter';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';
import App from './App';
import { AppProviders } from './components/ui';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root')!);
const render = (content: ReactNode) =>
  root.render(
    <React.StrictMode>
      <AppProviders>{content}</AppProviders>
    </React.StrictMode>
  );

// Development-only component gallery at /#ui-gallery. `import.meta.env.DEV`
// is statically false in production builds, so the gallery is not bundled.
if (import.meta.env.DEV && window.location.hash === '#ui-gallery') {
  void import('./components/ui/gallery/UiGallery').then(({ UiGallery }) =>
    render(<UiGallery />)
  );
} else {
  render(<App />);
}
